<template>
  <div class="containers">
    <table v-if="!isMoblie">
      <thead>
        <tr>
          <th></th>
          <th v-for="(item, index) in account" :key="index" :class="{
            highlight: selectedOption === item.id,
            enlarge: selectedOption === item.id,
          }" @click="selectOption(item.id)">
            <div class="selectTh" v-if="selectedOption === item.id">{{ item.title }}</div>
            {{ item.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(itemA, indexA) in accountFields" :key="indexA">
          <td>{{ getLabel(itemA) }}</td>
          <td v-for="(itemB, colIndex) in account" :key="colIndex" :class="{
            selected: selectedOption === itemB.id,
            enlarge: selectedOption === itemB.id,
          }" @click="selectOption(itemB.id)">
            <div v-if="selectedOption === itemB.id && accountFields.length - 1 === indexA" class="custom-content">
              {{ [true, false].includes(itemB[itemA]) ? '√' : itemB[itemA] }}
              <div class="button-container" :class="selectedOption">
                <a :href="itemB.startTradingLink" class=" inline-grid">
                  <el-button @click="startTrading" class="start-button">{{ itemB.startTradingText }}</el-button>
                </a>
                <a :href="itemB.openDemoAccountLink" class=" inline-grid">
                  <el-button @click="mockAccount" class="mock-button">{{ itemB.openDemoAccountText }}</el-button>
                </a>
              </div>
            </div>
            <div v-else>
              {{ [true, false].includes(itemB[itemA]) ? '√' : itemB[itemA] }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-else>
      <carousel v-if="account.length" :items="1" :nav="false" :dots="true" class=" w-full">
        <el-card shadow="never" class="rounded-2xl w-full" v-for="(item) in account" :key="item.id">
          <h1 class=" text-2xl font-medium pb-5">{{ item.title }}</h1>
          <el-descriptions title="" :column="1">
            <el-descriptions-item class=" w-full" :contentStyle="{ 'float': 'right' }" :label="getLabel(itemB) + '：'"
              v-for="(itemB) in accountFields" :key="itemB">
              {{ [true, false].includes(item[itemB]) ? '√' : item[itemB] }}
            </el-descriptions-item>
          </el-descriptions>
          <div class="flex justify-center mt-4">
            <a :href="item.startTradingLink" class=" inline-grid">
              <el-button @click="startTrading" class="start-button">{{ item.startTradingText }}</el-button>
            </a>
            <a :href="item.openDemoAccountLink" class=" inline-grid">
              <el-button @click="mockAccount" class="mock-button ml-2">{{ item.openDemoAccountText }}</el-button>
            </a>
          </div>
        </el-card>
      </carousel>
    </template>
  </div>
</template>
<script>
import { getAccountsList, getTranslations } from '@/api/index'
import carousel from '@/components/carousel/carousel.vue'

export default {
  props: {
    accountFields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedOption: 'standard',
      columns: [],
      account: [],
      translations: []
    }
  },
  components: { carousel },
  watch: {
  },
  created() {
    this.getTranslations()
    this.getAccountsList()
    this.getTranslations()
  },
  mounted() {

  },
  computed: {
    isMoblie() {
      return this.$store.getters.isMoblie
    }
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option
    },
    startTrading() {
      console.log('Start trading button clicked')
    },
    mockAccount() {
      console.log('Mock account button clicked')
    },
    getLabel(value, type = 'account') {
      const account = this.translations.account
      if (account) return account?.[value] || ''
    },
    async getAccountsList() {
      const params = {
        'populate[accounts][fields]': '*'
      }
      const result = await getAccountsList(params)
      this.account = result.data.attributes.accounts
      this.selectedOption = this.account[0].id || ''
    },
    async getTranslations() {
      const result = await getTranslations()
      this.translations = result.data.attributes.translations
    }
  }
}
</script>

<style scoped lang="scss">
.containers {
  display: flex;
  flex-direction: column;
  align-items: center;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background-color: #fff;
  border: 1px solid #F1F1F1;

}

th,
td {
  border-bottom: 1px solid #F1F1F1;
  /* padding: 1.5rem; */
  text-align: center;
  cursor: pointer;
  width: 10rem;
  height: 5rem;
  line-height: 4.8rem;
  transition: transform 0.3s, background-color 0.3s;
}

th {
  background-color: #EDEDED;
  font-weight: bold;
  font-size: 16px;
  color: #18181B;
  position: relative;
}

.selectTh {
  height: 7rem;
  position: absolute;
  top: -2rem;
  left: 0;
  background: linear-gradient(143deg, #F2994A 0%, #F2C94C 100%);
  width: 100%;
  border-radius: 1rem 1rem 0 0;
  line-height: 7rem;
  box-shadow: -1px 4px 14px 5px rgba(0, 0, 0, 0.12);
  font-size: 16px;
}

.custom-content {
  height: 13rem;
  position: absolute;
  bottom: -7.4rem;
  left: 0;
  background-color: #FAFAFA;
  width: 100%;
  border-radius: 0 0 1rem 1rem;
  line-height: 90px;
  box-shadow: 0px 8px 16px -1px rgba(0, 0, 0, 0.12);
}

.highlight {
  background-color: #FAFAFA;
}

.selected {
  position: relative;
  display: inline-block;
  background-color: #FAFAFA;
  width: 100%;
  transition: transform 0.2s ease;
  transform: scale(1);
  box-shadow: 0px 8px 16px -1px rgba(0, 0, 0, 0.12)
}

.enlarge {
  /* transform: scaleY(1.67) scaleX(1.07);  */
}

.button-container {
  position: absolute;
  top: 74px;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  height: calc(100% - 5rem);
}

.start-button,
.mock-button {
  margin: 10px 50px;
  border-radius: 6px;
  padding: 14px;
  /*border: none;
  border-radius: 5px;
  cursor: pointer; */
  background: linear-gradient(90deg, #4A6690 0%, #AF6BC2 100%);
  color: white;

}

.start-button {
  color: white;
}

.mock-button {
  // color: #AF6BC2;
  margin-left: 50px !important;
  border: none;
  background-color: initial;
}

.start-button:hover,
.mock-button:hover {
  opacity: 0.8;
}

::v-deep .el-descriptions__table {
  width: 100%;

  .el-descriptions-item__container {
    padding: 0.4rem 0;

    .el-descriptions-item__content {
      font-weight: bold;
    }
  }
}

@media screen and (max-width: 768px) {

  .start-button,
  .mock-button {
    margin: 0 0;
  }

  .mock-button {
    margin-left: 1rem !important;
  }
}
</style>
